export default "__VITE_ASSET__B7G8kHIo__"